import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { Router } from '@angular/router';
import { catchError, switchMap, finalize, filter, take } from 'rxjs/operators';
import { UiService } from '../services/ui/ui.service';
import { environment } from 'environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private isRefreshingToken!: boolean;
  private tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(
    ''
  );
  constructor(
    private authenticationService: AuthService,
    private router: Router,
    private uiService: UiService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to the api url
    const currentUser = this.authenticationService.currentUserValue;
    const isLoggedIn = localStorage.getItem('tokenKey');
    const isApiUrl = request.url.startsWith(environment.apiUrl);
    if (isLoggedIn && isApiUrl) {
      // TODO check pourquoi ça foire ici
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${localStorage.getItem('tokenKey')}`,
        },
      });
    }
    return next.handle(request);
  }

  // private refreshToken(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //     if (!this.isRefreshingToken) {
  //         this.isRefreshingToken = true;
  //         // Reset here so that the following request wait until the token
  //         // commes back from the refreshToken call
  //         this.tokenSubject.next('');
  //         return this.authenticationService.refreshToken()
  //             .pipe(
  //                 switchMap(newToken => {
  //                     if (newToken) {
  //                         this.tokenSubject.next(newToken.jwtToken);
  //                         return next.handle(this.addToken(req, newToken.jwtToken));
  //                     }
  //                     // if we don't get a new token, we are in trouble so logout
  //                     this.authenticationService.logout();
  //                     this.showMessage('auth.tokenRfFail.summary');
  //                     return throwError('');
  //                 }),
  //                 catchError(error => {
  //                     // if there is an exception calling 'refreshToken, bad news so logout
  //                     this.authenticationService.logout();
  //                     // this.uiService.openSnackBar('Votre session a expirée', '');
  //                     this.router.navigate(['/login']);
  //                     return throwError(error);
  //                 }),
  //                 finalize(() => this.isRefreshingToken = false)
  //             );
  //     } else {
  //         return this.tokenSubject.pipe(
  //             filter(token => token != null),
  //             take(1),
  //             switchMap(token => {
  //                 return next.handle(this.addToken(req, token));
  //             })
  //         );
  //     }
  // }
  private addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({ setHeaders: { Authorization: 'Bearer ' + token } });
  }
  private handleErrorMessage(err: HttpErrorResponse): void {
    const defaultText = `${err.status} ${err.statusText}`;
    switch (err.status) {
      case 403:
        this.handle403Error();
        break;
      case 400:
      case 409:
        if (err.error && err.error.error) {
          this.handle400Error(err.error.error, err.error.error_description);
        } else {
          this.showMessage(defaultText, false);
        }
        break;
      case 401:
        this.authenticationService.logout();
        break;
      case 404:
        this.showMessage('main.dialogs.serverNotFound.summary');
        break;
      case 500:
        this.handle500Error();
        break;
      default:
        // redirect to error page if error status is not a known one
        this.showMessage(defaultText, false);
      // this.router.navigate(['/error'], { queryParams: { code: err.status, message: err.statusText } });
    }
  }
  private handle403Error(): void {
    this.showMessage('auth.tokenRfFail.summary');
    // this.router.navigate(['/']);
  }
  private handle500Error(): void {
    this.router.navigate(['/error500']);
  }
  private handle400Error(error: string, errorDescription: string): void {
    switch (error) {
      case 'invalid_grant':
        this.handleInvalidGrant(errorDescription);
        break;
      case 'invalid_type':
        this.showMessage('files.uploadStates.typeError.summary');
        break;
      case 'username_already_used':
        this.showMessage('users.list.userExists.summary');
        break;
      default:
        this.showMessage(error, false);
    }
  }
  private handleInvalidGrant(errorDescription: string): void {
    switch (errorDescription) {
      // Login failed
      case 'invalid_username_or_password':
        this.showMessage('auth.invalidGrant.summary');
        break;
      // Token refresh failed
      default:
        // this.authenticationService.logout();
        this.showMessage('auth.tokenRfFail.summary');
    }
  }
  private showMessage(errorMessage: string, isTranslated = true): string {
    return errorMessage;
  }
}
